
import { Navigate } from "react-router-dom";

const WhatsAppPaymentPage = () => {
  return <Navigate to="/pricing?checkout=whatsapp_tier" replace />;
};

export default WhatsAppPaymentPage;
